export default "__VITE_ASSET__6lKND3ts__"